import { IEInsanity } from './IEInsanity';

export class NodeTextPosition {
    public static fromPoint(x: number, y: number): NodeTextPosition {
        if (x || y) {
            return getCursorPointByCaretPositionFromPoint(x, y)
                || getCursorPointByCaretRangeFromPoint(x, y)
                || getCursorPointByIETextRangeFromPoint(x, y);
        }
    }

    constructor(public container: Node, public offset: number) {
    }
}

/* tslint:disable */
declare global {
    interface Document {
        caretPositionFromPoint(x: Number, y: Number): { offsetNode: Node; offset: number; };
        caretRangeFromPoint(x: Number, y: Number): Range;
    }
    interface HTMLElement {
        createTextRange(): IERange;
    }
    interface IERange {
        readonly text: string;
        readonly startContainer: Node;
        readonly endContainer: Node;
        readonly startOffset: number;
        readonly endOffset: number;
        collapse(tostart: boolean): void;
        compareEndPoints(type: 'EndToEnd' | 'StartToStart', end: IERange): number;
        duplicate(): IERange;
        getBoundingClientRect(): ClientRect;
        getClientRects(): ClientRectList;
        move(type: 'character', offset: Number): number;
        moveEnd(type: 'character', offset: Number): number;
        moveStart(type: 'character', offset: Number): number;
        moveToElementText(el: Element): void;
        moveToPoint(x: Number, y: Number): void;
        parentElement(): Element;
        select(): void;
        setEnd(node: Node, offset: number): void;
        setEndPoint(type: 'EndToEnd' | 'StartToStart', range: IERange): void;
        setStart(node: Node, offset: number): void;
    }
}
/* tslint:enable */

function scrollX() {
    if (window.scrollX) { return window.scrollX; }
    if (window.document.documentElement.scrollLeft) { return window.document.documentElement.scrollLeft; }
    return 0;
}
function scrollY() {
    if (window.scrollY) { return window.scrollY; }
    if (window.document.documentElement.scrollTop) { return window.document.documentElement.scrollTop; }
    return 0;
}

function getCursorPointByCaretPositionFromPoint(x: number, y: number): NodeTextPosition {
    if (document.caretPositionFromPoint) {
        // Standard
        const pos = document.caretPositionFromPoint(x - scrollX(), y - scrollY());
        if (pos) {
            return new NodeTextPosition(pos.offsetNode, pos.offset);
        }
    }
}

function getCursorPointByCaretRangeFromPoint(x: number, y: number): NodeTextPosition {
    if (document.caretRangeFromPoint) {
        // Secondary
        const pos = document.caretRangeFromPoint(x - scrollX(), y - scrollY());
        if (pos) {
            return new NodeTextPosition(pos.startContainer, pos.startOffset);
        }
    }
}

function getCursorPointByIETextRangeFromPoint(pageX: number, pageY: number): NodeTextPosition {
    if (document.body.createTextRange && pageX > 0 && pageY > 0) {
        // IE Insanity
        try {
            const viewX = pageX - scrollX();
            const viewY = pageY - scrollY();
            const find = new IEInsanity(viewX, viewY);
            const rough = find.calcTextPositionRough();
            if (!rough) { return; }
            const exact = find.calcTextPositionExact(rough.offset);
            return exact;
        } catch (ex) {
            // tslint:disable-next-line
            console.error(`DOMOP: Problem resolving IE fallback text position ${pageX}:${pageY}, due to "${ex.message}"`);
        }
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/domop/NodeTextPosition.tsx